export default {
  "locale": {
    "label": "語言",
    "switchSuccess": "語言已切換",
    "zhCN": "簡體中文",
    "zhTW": "繁體中文",
    "en": "English"
  },
  "login": {
    "welcome": "歡迎使用",
    "title": "充電樁商戶管理平台",
    "usernamePlaceholder": "請輸入用戶名",
    "passwordPlaceholder": "密碼",
    "captchaPlaceholder": "驗證碼",
    "loginBtn": "登錄",
    "agreePrefix": "我已閱讀並同意 ",
    "userAgreement": "用戶協議",
    "accountLogin": "帳戶登錄",
    "usernameRequired": "用戶名不能為空!",
    "passwordRequired": "密碼不能為空",
    "agreementRequired": "請同意用戶協議",
    "loginSuccess": "登錄成功",
    "fetchUserInfoFailed": "獲取用戶信息失敗，請重試"
  },
  "error":{
    "wechatTip": "請您在微信瀏覽器中打開",
  },
  "advert": {
    "title": "廣告標題",
    "url": "鏈接",
    "showPage": "展示位置",
    "uploadImage": "上傳圖片",
    "showPage_tip_1": "掃碼成功",
    "showPage_tip_2": "充電開始",
    "showPage_tip_3": "問題反饋",
    "showPage_tip_4": "訂單列表",
    "uploadImageTip_1": "上傳圖片只能是 JPG 格式!",
    "uploadImageTip_2": "上傳圖片大小不能超過 2MB!",
    "success": "修改成功",
    "addSuccess": "添加成功",
    "deleteSuccess": "刪除成功",
    "noData": "暫無廣告記錄",
    "addNotice": "新增廣告",
    "siteName": "站點名稱",
  },
  "card": {
    "cardNo": "卡號",
    "physicalCardNo": "物理卡號",
    "sum": "餘額",
    "mobile": "手機號",
    "realName": "代理商",
    "save": "保存",
    "selectOperator": "請選擇代理商",
    "inputCardNo": "請輸入卡號",
    "inputPhysicalCardNo": "請輸入物理卡號",
    "inputSum": "請輸入餘額",
    "inputMobile": "請輸入手機號",
    "cardNoError": "請輸入卡號(ABCDEF)+數字(0-9)",
    "inputTip":"請輸入",
    "inputLegalAmount":"請輸入合法金額",
    "inputPhone":"請輸入正確的手機號",
    "editCard": "編輯卡",
    "addCard": "新增卡",
    "addCardFailed": "新增卡失敗",
    "editCardFailed": "編輯卡失敗",
    "card_1":"請輸入卡號/手機號",
    "card_2":"暫時沒有IC卡",
    "card_3":"請點擊右側 ’添加‘ 按鈕",
    "card_4":"開始您的運營之旅吧！",
    "card_5":"添加",
    "card_6":"全部卡",
    "card_7":"卡號：",
    "card_8":"用戶手機號",
    "card_9":"卡餘額",
    "card_10":"綁定日期",
    "card_11":"掛失",
    "card_12":"充值記錄",
    "card_13":"使用記錄",
    "card_14":"您是否確定要對該卡片進行掛失處理？",
    "card_15":"我再想想",
    "card_16":"未知",
    "card_17":"暫無",
    "card_18":"已加載全部數據",
    "card_19":"暫無數據",
    "card_20":"獲取數據失敗",
    "card_21":"當前卡片已掛失",
    "card_22":"掛失成功",
    "card_23":"掛失失敗",
    "card_24":"新建",
    "card_25":"篩選",
    "card_26":"用戶名",
    "card_27":"未綁定",
    "card_28":"電話",
    "card_29":"無",
    "card_30":"狀態",
    "card_31":"暫無卡片",
    "card_32":"正常",
    "card_33":"已掛失",
    "card_34":"未啟用",
    "card_35":"添加卡",
    "card_36":"卡編",
    "card_37":"請輸入號碼",
    "card_38":"卡號不能為空",
    "card_39":"餘額不能為空",
    "card_40":"手機號不能為空",
    "card_41":"手機號碼有誤，請重填",
    "card_42":"確定要掛失此卡？",
    "card_43":"取消掛失",
    "card_44":"搜索卡號/手機號",
    "card_45":"操作",
    "card_46":"時間",
    "card_47":"暫無更多",
    "card_48":"",
    "card_49":"卡編號: ",
    "card_50":"暫無充值記錄",
    "card_51":"充值 ",
    "card_52":"消費",
    "card_53":"贈送",
    "card_54":"系統充值",
    "card_55":"退款",
    "card_56":"退款失敗",
    "card_57":"轉款",
    "card_58":"金額",
    "card_59":"日期",
    "card_60":"實際時間",
    "card_61":"預計時間",
    "card_62":"充電樁編號",
    "card_63":"暫無使用記錄",
    "card_64":"卡號必須為數字!",
    "card_65":"到底了",
    "card_66":"更多",
    "card_67":"查看",
    "card_68":"充值",
    "card_69":"綁定用戶",
    "card_70":"解綁用戶",
    "card_71":"補卡",
    "card_72":"卡詳情",
    "card_73":"充值金額",
    "card_74":"請輸入充值金額",
    "card_75":"充值成功",
    "card_76":"充值失敗",
    "card_77":"新卡號",
    "card_78":"請輸入新卡號",
    "card_79":"補卡成功",
    "card_80":"補卡失敗",
    "card_81":"確定要刪除該卡？",
    "card_82":"刪除成功",
    "card_83":"刪除失敗",
    "card_84":"確定要解綁該用戶？",
    "card_85":"解綁成功",
    "card_86":"解綁失敗",
    "card_87":"取消掛失成功",
    "card_88":"取消掛失失敗",
    "card_89":"綁定成功",
    "card_90":"綁定失敗",
  },
  "equip": {
    "equip_1": "您還沒有添加設備",
    "equip_2": "請點擊下方 ’添加設備‘ 按鈕",
    "equip_3": "全部設備",
    "equip_4": "運行",
    "equip_5": "離線",
    "equip_6": "總收益",
    "equip_7": "已充電量",
    "equip_8": "充電次數",
    "equip_9": "充電時長",
    "equip_10": "規則設置",
    "equip_11": "選擇規則",
    "equip_12": "請選擇規則",
    "equip_13": "編輯",
    "equip_14": "全部",
    "equip_15": "端口管理",
    "equip_pileAccess": "樁訪問屬性",
    "equip_pileAccess_0": "公用設備",
    "equip_pileAccess_1": "固定設備",
    "equip_pileAccess_tip": "請選擇樁訪問屬性",
    "equip_16": "規則管理",
    "equip_17": "查看收益",
    "equip_18": "編輯",
    "equip_19": "新增設備",
    "equip_20": "小區名稱/設備編號",
    "equip_21": "台",
    "equip_22": "充電樁編號",
    "equip_23": "暫無設備",
    "equip_24": "充電樁編碼",
    "equip_25": "充電樁名稱",
    "equip_26": "充電樁類型",
    "equip_27": "槍口數量",
    "equip_28": "電流（A）",
    "equip_29": "電壓（V）",
    "equip_30": "功率（kW）",
    "equip_31": "sim卡序列號",
    "equip_32": "sim卡到期時間",
    "equip_33": "請選擇",
    "equip_34": "站點",
    "equip_35": "保存",
    "equip_portType": "槍口類型",
    "equip_portType_1": "單槍",
    "equip_portType_2": "雙槍",
    "equip_portType_8": "一拖八",
    "equip_portType_10": "一拖十",
    "equip_portType_16": "一拖十六",
    "equip_portType_tip": "請選擇槍口類型",
    "equip_supply": "廠商設備型號",
    "equip_supply_tip": "請選擇廠商設備型號",
    "equip_cpFeeType": "計費類型",
    "equip_cpFeeType_charge": "收費",
    "equip_cpFeeType_free": "免費",
    "equip_protocolType": "協議類型",
    "equip_protocolType_tip": "請選擇協議類型",
    "equip_36": "請選擇時間日期",
    "equip_37": "請輸入正確的數值",
    "equip_38": "請輸入充電樁編號",
    "equip_39": "電樁編號限制14位數字",
    "equip_40": "請輸入電流",
    "equip_41": "請輸入電壓",
    "equip_42": "請輸入最大功率",
    "equip_43": "請輸入充電樁名稱",
    "equip_44": "請輸入端口數量",
    "equip_45": "請選擇充電樁類型",
    "equip_46": "請選擇狀態",
    "equip_48": "請選擇站點",
    "equip_49": "設備編輯",
    "equip_50": "保存成功",
    "equip_51": "保存失敗",
    "equip_52": "接口異常",
    "equip_53": "慢充",
    "equip_54": "快充",
    "equip_pileType_0": "中充(3.5kW-7kW)",
    "equip_pileType_1": "快充(11-22kW)",
    "equip_pileType_2": "特快充(40-60kW)",
    "equip_pileType_3": "超快充(120kW)",
    "equip_55": "禁用",
    "equip_56": "啟用",
    "equip_57": "設備編號",
    "equip_58": "設備名稱",
    "equip_59": "sim卡",
    "equip_60": "投放地址",
    "equip_61": "省",
    "equip_62": "市",
    "equip_63": "區",
    "equip_64": "詳細小區",
    "equip_65": "設備類型",
    "equip_66": "運行狀態",
    "equip_67": "請選擇地區",
    "equip_68": "請選擇小區",
    "equip_69": "請選擇收費類型",
    "equip_70": "請選擇運行狀態",
    "equip_71": "暫無該地區小區數據",
    "equip_72": "輸入自定義小區",
    "equip_73": "請輸入正確充電樁編號",
    "equip_74": "請輸入充電樁名",
    "equip_75": "請選擇充電樁所在小區",
    "equip_76": "請選擇充電樁收費類型",
    "equip_77": "總收益(HKD)",
    "equip_78": "已充電量(度)",
    "equip_79": "充電時長(小時)",
    "equip_80": "編輯端口",
    "equip_81": "編輯名稱",
    "equip_82": "端口狀態",
    "equip_83": "請選擇端口狀態",
    "equip_84": "離線",
    "equip_85": "故障",
    "equip_86": "空閒",
    "equip_87": "充電",
    "equip_88": "已插槍",
    "equip_89": "占用",
    "equip_90": "操作成功",
    "equip_91": "操作失敗",
    "equip_92": "此端口正在使用無法編輯",
    "equip_93": "請填寫端口名稱",
    "equip_94": "編輯端口成功",
    "equip_95": "總耗電量",
    "equip_96": "暫無時間",
    "equip_97": "暫無端口",
    "equip_98": "添加端口",
    "equip_99": "端口名稱",
    "equip_100": "請輸入端口名稱",
    "equip_101": "使用",
    "equip_102": "刪除端口成功",
    "equip_103": "公眾號規則",
    "equip_104": "去編輯選中規則",
    "equip_105": "卡規則",
    "equip_106": "請選擇公眾號規則",
    "equip_107": "請選擇卡規則",
    "equip_108": "請先選擇規則",
    "equip_109": "請選擇公眾規則",
    "equip_110": "設置規則成功",
    "equip_111": "在線",
    "equip_112": "離線",
    "equip_113": "已耗電量",
    "equip_114": "度",
    "equip_115": "電費",
    "equip_116": "服務費",
    "equip_117": "小時",
    "equip_118": "規則名稱",
    "equip_119": "充電樁限制8位數字",
    "equip_120": "電流",
    "equip_121": "電壓",
    "equip_122": "最大功率",
    "equip_123": "編輯保存",
    "equip_124": "立即添加",
    "equip_125": "請輸入數字",
    "equip_126": "請輸入卡序號",
    "equip_127": "請選擇到期時間",
    "equip_128": "開啟",
    "equip_129": "關閉",
    "equip_130": "添加端口成功",
    "equip_131": "設備總收益",
  },
  "equipment":{
    "equipment_1": "收益情況",
    "equipment_2": "合計(HKD)",
    "equipment_3": "暫無記錄",
    "equipment_4": "請輸入訂單號",
    "equipment_5": "收益",
    "equipment_6": "收益總額",
    "equipment_7": "訂單數量",
    "equipment_8": "單號",
    "equipment_9": "開始時間",
    "equipment_10": "結束時間",
    "equipment_11": "暫無訂單記錄",
    "equipment_12": "我的收益",
    "equipment_13": "用戶消費",
    "equipment_14": "全部",
    "equipment_15": "消耗電量",
    "equipment_16": "退費金額",
    "equipment_17": "消費紙巾包",
    "equipment_18": "刷卡消費額",
    "equipment_19": "使用時長",
    "equipment_20": "消費金額",
    "equipment_21": "實際消費",
    "equipment_22": "線下投幣",
    "equipment_23": "充值卡",
    "equipment_24": "廣告",
    "equipment_25": "充值",
    "equipment_26": "帳戶餘額",
    "equipment_27": "立即提現",
    "equipment_28": "數據看板",
    "equipment_29": "本月收益",
    "equipment_30": "今日收益",
    "equipment_31": "完成訂單",
    "equipment_32": "設備總數",
    "equipment_33": "設備總耗電量",
    "equipment_34": "帳單明細",
    "equipment_35": "地址統計",
    "equipment_36": "時間統計",
    "equipment_37": "本月總收益",
    "equipment_38": "在線支付",
    "equipment_39": "卡支付",
    "equipment_40": "線上",
    "equipment_41": "線下",
  },
  "mine":{
    "mine_1": "常用功能",
    "mine_2": "經營數據",
    "mine_3": "全部電站",
    "mine_4": "全部時間",
    "mine_5": "清空",
    "mine_6": "全部收益",
    "mine_7": "總收益",
    "mine_8": "電費",
    "mine_9": "服務費",
    "mine_10": "運行",
    "mine_11": "離線",
    "mine_12": "總交易額",
    "mine_13": "電費",
    "mine_14": "服務費",
    "mine_15": "充電量(度)",
    "mine_16": "充電次數",
    "mine_17": "站點管理",
    "mine_18": "設備管理",
    "mine_19": "訂單管理",
    "mine_20": "IC卡管理",
    "mine_21": "規則管理",
    "mine_22": "用戶管理",
    "mine_23": "問題反饋",
    "mine_24": "分成匯總",
    "mine_25": "小區管理",
    "mine_26": "電卡管理",
    "mine_27": "提現記錄",
    "mine_28": "當前餘額(HKD)",
    "mine_29": "可提現餘額(HKD)",
    "mine_30": "平台凍結金額(HKD)",
    "mine_31": "提現帳戶",
    "mine_32": "提現金額",
    "mine_33": "全部提現",
    "mine_34": "最低提現金額",
    "mine_35": "本次提現手續費",
    "mine_36": "自動提現",
    "mine_37": "是",
    "mine_38": "最低收取",
    "mine_39": "手續費",
    "mine_40": "上傳發票",
    "mine_41": "僅支持pdf，單個文件不超過500KB，最多3個",
    "mine_42": "提現",
    "mine_43": "提現提醒",
    "mine_44": "實際到帳",
    "mine_45": "確認提現",
    "mine_46": "我再想想",
    "mine_47": "提現金額必須大於0",
    "mine_48": "提現金額最多保留兩位小數",
    "mine_49": "提現金額不能大於可提現餘額",
    "mine_50": "提現金額不能小於最低提現金額",
    "mine_51": "實際到帳{actual_money}， 手續費{transFree}",
    "mine_52": "正在提現中",
    "mine_53": "最多只能上傳3個發票",
    "mine_54": "僅支持PDF文件",
    "mine_55": "文件大小不能超過500KB",
    "mine_56": "上傳中...",
    "mine_57": "上傳失敗",
    "mine_58": "您所屬的運營商沒有正確配置公眾號信息",
    "mine_59": "綁定成功",
    "mine_60": "歡迎回來，",
    "mine_61": "進入工作台",
    "mine_62": "創建時間",
    "mine_63": "單車",
    "mine_64": "汽車",
    "mine_65": "累計收益",
    "mine_66": "今日收益",
    "mine_67": "帳戶餘額",
    "mine_68": "去提現",
    "mine_69": "本月收益",
    "mine_70": "經營數據",
    "mine_71": "經營金額",
    "mine_72": "",
    "mine_73": "訂單總金額",
    "mine_74": "我的分成金額",
    "mine_75": "查看分成明細",
    "mine_76": "分成統計",
    "mine_77": "累計金額",
    "mine_78": "近一周",
    "mine_79": "近一月",
    "mine_80": "近一年",
    "mine_81": "累計電量(度)",
    "mine_82": "退款金額",
    "mine_83": "訂單數",
    "mine_84": "注冊用戶(人)",
    "mine_85": "金額",
    "mine_86": "運行設備",
    "mine_87": "離線設備",
    "mine_88": "當前可提現餘額為0，無法提現",
    "mine_89": "充值金額",
    "mine_90": "退款金額",
    "mine_91": "退款金額",
    "mine_92": "訂單總數(單)",
    "mine_93": "設備狀態",
    "mine_94": "站點總數",
    "mine_95": "設備統計",
    "mine_96": "查看更多",
    "mine_97": "銷售總額",
    "mine_98": "退款總額",
    "mine_99": "退款訂單數",
    "mine_100": "訂單數",
    "mine_101": "有效訂單數",
    "mine_102": "訂單總收益(HKD)",
    "mine_103": "分成總收益(HKD)",
    "mine_104": "累計電費(HKD)",
    "mine_105": "累計服務費(HKD)",
    "mine_106": "設備總數(台)",
    "mine_107": "端口數量(台)",
    "mine_108": "訂單數(單)",
    "mine_109": "累計充電量(度)",
    "mine_110": "銷售統計",
    "mine_111": "設備統計",
    "mine_112": "金額(HKD)",
    "mine_113": "耗電量(度)",
    "mine_114": "使用率",
    "mine_115": "有效端口",
    "mine_116": "損壞端口",
    "mine_117": "近一季",
    "mine_118": "用戶",
    "mine_119": "電站名稱",
    "mine_120": "訂單號",
    "mine_121": "訂單金額",
    "mine_122": "本次分成金額",
    "mine_123": "暫無分成記錄",
    "mine_124": "天",
    "mine_125": "小時",
    "mine_126": "分",
    "mine_127": "提現單號",
    "mine_128": "提現日期",
    "mine_129": "提現金額",
    "mine_130": "實際到帳金額",
    "mine_131": "提現狀態",
    "mine_132": "未審批",
    "mine_133": "過程中",
    "mine_134": "成功",
    "mine_135": "失敗",
    "mine_136": "-提現記錄",
    "mine_137": "退出登錄",
    "mine_138": "提現記錄",
    "mine_139": "是否確定退出當前帳號？",
    "mine_140": "正在退出",
    "mine_141": "訂單總金額",
    "mine_142": "我的分成金額",
    "mine_143": "總充電費",
    "mine_144": "總服務費",
    "mine_145": "舊密碼",
    "mine_146": "新密碼",
    "mine_147": "確認新密碼",
    "mine_148": "兩次輸入的密碼不正確",
    "mine_149": "請填寫舊密碼",
    "mine_150": "請填寫新密碼",
    "mine_151": "請填寫確認新密碼",
    "mine_152": "密碼修改成功",
    "mine_153": "密碼修改失敗",
    "mine_154": "請輸入提現金額",
    "mine_155": "已綁定微信",
    "mine_156": "實時到帳",
    "mine_157": "提現成功",
    "mine_158": "IC卡",
    "mine_159": "請選擇卡號",
    "mine_160": "轉帳金額",
    "mine_161": "請輸入金額",
    "mine_162": "帳戶餘額",
    "mine_163": "請輸入非負數字",
    "mine_164": "可轉帳金額不得超過",
    "mine_165": "轉帳成功",
    "mine_166": "轉帳失敗",
    "mine_167": "退款記錄",
    "mine_168": "暫無用戶",
    "mine_169": "全部用戶",
    "mine_170": "注冊時間",
    "mine_171": "累計充值",
    "mine_172": "卡餘額",
    "mine_173": "轉帳",
    "mine_174": "可轉帳金額",
    "mine_175": "此用戶未擁有儲值卡，無法轉帳",
    "mine_176": "請輸入用戶暱稱或者手機號",
    "mine_177": "餘額數",
    "mine_178": "累計充值(HKD)",
    "mine_179": "餘額(HKD)",
    "mine_180": "卡餘額(HKD)",
  },
  "order":{
    "order_1": "暫無訂單數據",
    "order_2": "全部訂單",
    "order_3": "訂單編號",
    "order_4": "預計結束時間",
    "order_5": "充電金額",
    "order_6": "支付狀態",
    "order_7": "訂單信息",
    "order_8": "訂單類型",
    "order_9": "退款金額不能大於訂單金額",
    "order_10": "請輸入退款金額",
    "order_11": "訂單狀態跟蹤",
    "order_12": "團體訂單",
    "order_13": "否",
    "order_14": "費用信息",
    "order_15": "電費成本費用",
    "order_16": "優惠券優惠金額",
    "order_17": "站點優惠金額",
    "order_18": "電費優惠總金額",
    "order_19": "服務費優惠總金額",
    "order_20": "積分信息",
    "order_21": "充電積分",
    "order_22": "停車積分",
    "order_23": "抵扣積分",
    "order_24": "抵扣金額",
    "order_25": "滿積分服務費優惠金額",
    "order_26": "設備信息",
    "order_27": "電站位置",
    "order_28": "用戶信息",
    "order_29": "支付信息",
    "order_30": "支付方式",
    "order_31": "線上支付",
    "order_32": "支付時間",
    "order_33": "申請退款",
    "order_34": "下單",
    "order_35": "支付成功",
    "order_36": "完成",
    "order_37": "結算中",
    "order_38": "手動結算",
    "order_39": "實際支付金額",
    "order_40": "按時間查詢",
    "order_41": "當日查詢：按小時顯示數據；",
    "order_42": "天數查詢：按天顯示數據；",
    "order_43": "請選擇開始日期",
    "order_44": "請選擇結束日期",
    "order_45": "訂單數",
    "order_46": "銷售額",
    "order_47": "結束時間不能小於開始時間",
    "order_48": "至",
    "order_49": "端口號",
    "order_50": "請輸入充電樁端口號",
    "order_51": "電量",
    "order_52": "時長",
    "order_53": "端口變更",
    "order_54": "訂單狀態",
    "order_55": "地址",
    "order_56": "端口",
    "order_57": "實際充電時長",
  },
  "inuseorderdetial": {
    "briefPlaceOrder": "客戶下單",
    "briefStartCharge": "開始充電",
    "briefCharging": "充電中",
    "briefEndCharge": "結束充電",
    "briefChargeTerminated": "充電終止",
    "briefSettling": "結算中",
    "briefCompleteOrder": "完成訂單",
    "traceClientRemoteStart": "通過用戶端，遠程啟動充電",
    "traceRemoteStart": "遠程啟動充電",
    "traceRemoteStartSuccess": "遠程啟動充電成功，開始充電",
    "traceCharging": "充電中",
    "traceManualStop": "用戶手動結束了充電",
    "traceRemoteStop": "遠程停止",
    "traceStopped": "停止充電",
    "traceSettling": "訂單結算中",
    "traceConsumptionSuccess": "消費成功，本次消費{amount}，帳戶餘額：{balance}",
    "traceCompleted": "訂單已完成"
  },
  "promotion":{
    "promotion_1": "促銷名稱",
    "promotion_2": "滿足金額",
    "promotion_3": "贈送金額",
    "promotion_4": "狀態",
    "promotion_5": "是否顯示",
    "promotion_6": "正常",
    "promotion_7": "禁用",
    "promotion_8": "不顯示",
    "promotion_9": "顯示",
    "promotion_10": "請將信息填寫完整後提交",
    "promotion_11": "修改成功",
    "promotion_12": "添加成功",
    "promotion_13": "新增促銷",
    "promotion_14": "促銷滿足金額",
    "promotion_15": "贈送金額",
    "promotion_16": "創建時間",
    "promotion_17": "",
    "promotion_18": "",
    "promotion_19": "",
    "promotion_20": "",
    "promotion_21": "",
    "promotion_22": "",
    "promotion_23": "",
    "promotion_24": "",
    "promotion_25": "",
    "promotion_26": "",
    "promotion_27": "",
    "promotion_28": "",
    "promotion_29": "",
    "promotion_30": "",
    "promotion_31": "",
    "promotion_32": "",
    "promotion_33": "",
    "promotion_34": "",
    "promotion_35": "",
    "promotion_36": "",
    "promotion_37": "",
    "promotion_38": "",
  },
  "response":{
    "response_1": "用戶暱稱",
    "response_2": "聯繫電話",
    "response_3": "問題類型",
    "response_4": "問題描述",
    "response_5": "提交時間",
    "response_6": "設備名稱",
    "response_7": "設備編號",
    "response_8": "端口號",
    "response_9": "批註",
    "response_10": "處理人",
    "response_11": "處理時間",
    "response_12": "填寫批註",
    "response_13": "請輸入批註",
    "response_14": "批註成功",
    "response_15": "暫時沒有問題反饋",
    "response_16": "全部反饋",
    "response_17": "待反饋",
    "response_18": "其他原因",
    "response_19": "用戶手機號",
    "response_20": "設備名稱",
    "response_21": "充電樁編碼",
    "response_22": "問題描述",
    "response_23": "暫無反饋記錄",
    "response_24": "反饋狀態",
    "response_25": "反饋類型",
    "response_26": "請選擇反饋狀態",
    "response_27": "請選擇反饋類型",
    "response_28": "處理完成",
    "response_29": "未處理",
    "response_30": "樁編碼",
    "response_31": "端口號",
    "response_32": "其他類型",
    "response_33": "反饋時間",
    "response_34": "處理信息",
    "response_35": "處理批註",
    "response_36": "提交成功",
  },
  "rules":{
    "rules_1": "規則名稱",
    "rules_2": "請輸入計費規則名稱",
    "rules_3": "費用設置",
    "rules_4": "注：峰、平、谷時段價格均為必填項。因各地電價不同，請根據當地實際 電價填寫。",
    "rules_5": "電費（HKD/度）",
    "rules_6": "服務費（HKD/度）",
    "rules_7": "24小時尖峰平谷分布設置",
    "rules_8": "注：時間設置最小間隔為30分鐘；最多可設置48個計費時段。",
    "rules_9": "時段",
    "rules_10": "費用類型",
    "rules_11": "添加",
    "rules_12": "檔位顯示方式",
    "rules_13": "充電車主選擇支付金額的頁面",
    "rules_14": "是否開啟智能充滿",
    "rules_15": "時長",
    "rules_16": "金額",
    "rules_17": "電量",
    "rules_18": "選擇時間",
    "rules_19": "尖時段",
    "rules_20": "峰時段",
    "rules_21": "平時段",
    "rules_22": "谷時段",
    "rules_23": "請輸入必填項",
    "rules_24": "開始時間和截止時間不能相同",
    "rules_25": "開始時間不能小於結束時間",
    "rules_26": "時間必須連續",
    "rules_27": "最多只能設置48個時間段哦",
    "rules_28": "時長(h)",
    "rules_29": "費用(HKD)",
    "rules_30": "單價/h",
    "rules_31": "類型",
    "rules_32": "收費類型",
    "rules_33": "創建時間",
    "rules_34": "暫無規則價格記錄",
    "rules_35": "新建規則價格",
    "rules_36": "計費類型",
    "rules_37": "請輸入計費類型",
    "rules_38": "固定",
    "rules_39": "請輸入類型",
    "rules_40": "時長",
    "rules_41": "請輸入時長",
    "rules_42": "請輸入單價",
    "rules_43": "請輸入費用",
    "rules_44": "超出時間",
    "rules_45": "規則大於某值",
    "rules_46": "超出價格",
    "rules_47": "規則大於某值時價格",
    "rules_48": "請選擇計費類型",
    "rules_49": "請選擇類型",
    "rules_50": "編輯規則價格",
    "rules_51": "自定義時長",
    "rules_52": "複製該規則？",
    "rules_53": "複製價格成功",
    "rules_54": "取消複製",
    "rules_55": "添加價格成功",
    "rules_56": "修改價格成功",
    "rules_57": "確定要刪除？",
    "rules_58": "刪除成功",
    "rules_59": "取消刪除",
    "rules_60": "小時計費",
    "rules_61": "暫時沒有規則數據",
    "rules_62": "全部規則",
    "rules_63": "應用設備",
    "rules_64": "複製",
    "rules_65": "複製規則",
    "rules_66": "您是否確定要刪除該計費規則？",
    "rules_67": "我再想想",
    "rules_68": "請輸入規則名稱",
    "rules_69": "複製規則成功",
    "rules_70": "請輸入規則名稱",
    "rules_71": "複製規則失敗",
    "rules_72": "取消複製規則",
    "rules_73": "確認刪除？",
    "rules_74": "刪除失敗",
    "rules_75": "請輸入規則",
    "rules_76": "默認規則",
    "rules_77": "暫無規則",
    "rules_78": "請輸入新規則名",
    "rules_79": "規則名不能為空",
    "rules_80": "規則設置",
    "rules_81": "新增規則",
    "rules_82": "設置規則成功",
    "rules_83": "規則編輯",
    "rules_84": "添加價格失敗",
    "rules_85": "請輸入時長為數字",
    "rules_86": "請輸入單價為數字",
    "rules_87": "修改價格失敗",
    "rules_88": "站點名",
    "rules_89": "供應商",
    "rules_90": "用戶充電時長配置",
    "rules_91": "用戶選擇充電時長配置",
    "rules_92": "+添加時長",
    "rules_93": "計費配置",
    "rules_94": "按小時計費",
    "rules_95": "按電量計費",
    "rules_96": "按功率計費",
    "rules_97": "不限功率",
    "rules_98": "功率段",
    "rules_99": "金額",
    "rules_100": "HKD/小時",
    "rules_101": "服務費設置",
    "rules_102": "HKD/度",
    "rules_103": "收費說明：實際使用電量*（電費+服務費）",
    "rules_104": "+添加功率",
    "rules_105": "收費模式",
    "rules_106": "編輯規則失敗",
    "rules_107": "成本（HKD/度）",
    "rules_108": "成本電費應小於等於對應的電費金額",
  },
  "site":{
    "site_1": "站點名稱",
    "site_2": "請輸入站點名稱",
    "site_3": "所屬地區",
    "site_4": "省/市/區",
    "site_5": "位置選擇",
    "site_6": "選擇位置",
    "site_7": "站點圖片",
    "site_8": "停車信息",
    "site_9": "停車收費類型",
    "site_10": "停車收費",
    "site_11": "停車免費",
    "site_12": "是否支持開收據",
    "site_13": "不支持",
    "site_14": "支持",
    "site_15": "配套設施",
    "site_plotNature": "場站屬性",
    "site_plotNature_1": "公共",
    "site_plotNature_2": "工作場所",
    "site_plotNature_3": "住宅",
    "site_agent": "所屬代理商",
    "site_agent_placeholder": "請選擇所屬代理商",
    "site_16": "免費WIFI",
    "site_17": "便利店",
    "site_18": "洗車",
    "site_19": "廁所",
    "site_20": "負責人",
    "site_21": "請輸入負責人",
    "site_22": "聯繫電話",
    "site_23": "請輸入11位手機號",
    "site_24": "是否支持即插即充",
    "site_25": "不支持",
    "site_26": "支持",
    "site_27": "運營狀態",
    "site_28": "停業",
    "site_29": "在營",
    "site_30": "站點運營時間",
    "site_31": "開始時間",
    "site_32": "結束時間",
    "site_33": "應用是否顯示",
    "site_34": "隱藏",
    "site_35": "顯示",
    "site_36": "選擇地區",
    "site_37": "請選擇時間",
    "site_38": "相冊",
    "site_39": "請輸入站點名稱",
    "site_40": "長度在 3 到 10 個字符",
    "site_41": "暫無功能",
    "site_42": "上傳失敗",
    "site_43": "上傳圖片只能是 JPG / PNG格式!",
    "site_44": "上傳圖片大小不能超過 2MB!",
    "site_45": "請將信息填寫完整後提交",
    "site_46": "請輸入11位手機號",
    "site_47": "請輸入正確的手機號格式",
    "site_48": "修改成功",
    "site_49": "添加成功",
    "site_50": "添加失敗",
    "site_51": "您還沒有添加充電站",
    "site_52": "請點擊下方 ’添加充電站‘ 按鈕",
    "site_53": "開始您的運營之旅吧！",
    "site_54": "全部站點",
    "site_55": "位置",
    "site_56": "搜索地點",
    "site_57": "北京市政府",
    "site_58": "基本信息",
    "site_59": "小區名稱",
    "site_60": "詳細地址",
    "site_61": "請輸入詳細地址",
    "site_62": "添加圖片",
    "site_63": "請輸入小區名稱",
    "site_64": "全部小區",
    "site_65": "新增小區",
    "site_66": "站點編號",
    "site_67": "啟用積分抵現",
    "site_68": "啟用及時駛離贈送積分",
    "site_69": "啟用充電贈送積分",
    "site_70": "請輸入站點編號",
    "site_71": "是",
    "site_72": "否",
    "site_73": "請輸入手機號",
    "site_74": "",
    "site_75": "",
    "site_76": "",
    "site_77": "占樁費設定",
    "site_78": "分成設定",
    "site_79": "是否開啟占樁費",
    "site_80": "免費占用時長",
    "site_81": "收費單價",
    "site_82": "封頂金額",
    "site_83": "分鐘",
    "site_84": "HKD/分鐘",
    "site_85": "",
    "site_86": "請輸入免費占用時長",
    "site_87": "請輸入收費單價",
    "site_88": "請輸入封頂金額",
    "site_89": "占樁費設定成功",
    "site_90": "占樁費設定失敗",
    "site_91": "獲取占樁費配置失敗",
    "site_92": "站點分成設定",
    "site_93": "代理商名稱",
    "site_94": "分成方式",
    "site_95": "請選擇分成方式",
    "site_96": "代理商分成比例(%)",
    "site_97": "平台分成比例(%)",
    "site_98": "電費",
    "site_99": "服務費",
    "site_100": "電費+服務費",
    "site_101": "分成方式設定成功",
    "site_102": "分成方式設定失敗",
    "site_103": "收款人",
    "site_104": "電費利潤分成比例(%)",
    "site_105": "成本電費分成比例(%)",
    "site_106": "服務費分成比例(%)",
    "site_107": "備註",
    "site_108": "電費利潤分成比例總和不等於100",
    "site_109": "成本電費分成比例總和不等於100",
    "site_110": "服務費分成比例總和不等於100",
    "site_111": "請輸入代理商分成比例",
    "site_112": "自動計算",
    "site_113": "溫馨提示1：分成比例僅需填寫整數（如：想分60%給某個用戶則填「60」）；若不需分成給第三方人員，請設定100%給站點歸屬方。",
    "site_114": "溫馨提示2：所有分成比例的總和必須等於100。",
    "site_115": "溫馨提示3：電費利潤=電費-成本電費；",
    "site_116": "HKD",

  },
  "admin":{
    "admin_1": "首頁",
    "admin_2": "我的",
    "admin_3": "經營管理",
    "admin_4": "您所屬的運營商沒有正確配置公眾號信息",
    "admin_5": "分成明細",
    "admin_6": "訂單列表",
    "admin_7": "訂單詳情",
    "admin_8": "退款",
    "admin_9": "訂單編輯",
    "admin_10": "查看收益",
    "admin_11": "卡管理",
    "admin_12": "卡充值記錄",
    "admin_13": "卡使用記錄",
    "admin_14": "反饋管理",
    "admin_15": "反饋詳情",
    "admin_16": "餘額詳情",
    "admin_17": "綁定微信",
    "admin_18": "賬號設置",
    "admin_19": "語言",
    "admin_20": "提現記錄",
    "admin_21": "設備管理",
    "admin_22": "設備編輯",
    "admin_23": "設備新增",
    "admin_24": "設備埠",
    "admin_25": "用戶管理",
    "admin_26": "轉賬",
    "admin_27": "規則管理",
    "admin_28": "選擇規則",
    "admin_29": "規則編輯",
    "admin_30": "站點管理",
    "admin_31": "小區管理",
    "admin_32": "站點新增/編輯",
    "admin_33": "廣告管理",
    "admin_34": "廣告新增/編輯",
    "admin_35": "促銷管理",
    "admin_36": "促銷新增/編輯",
    "admin_37": "提現",
    "admin_38": "用戶充值記錄",
    "admin_39": "卡新增/編輯",
    "admin_40": "問題詳情",
    "admin_41": "用戶協議",
    "admin_42": "分成彙總"

  },
  "common": {
    "cancel": "取消",
    "confirm": "確定",
    "edit": "編輯",
    "delete": "刪除",
    "noData": "暫無數據",
    "back": "返回",
    "success": "操作成功",
    "failed": "操作失敗",
    "noMore": "沒有更多了",
    "search": "搜索",
    "tip": "提示",
    "submit": "提交",
    "add": "新增"
  }
};
